import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import { userSlice } from "../redux/user/userSlice";
import {
  getAccessLabel,
  getProjectStatusDisplay,
} from "../utils/projectAccess";
import {
  formatAnalyticsCount,
  getProjectAnalyticsPreview,
} from "../utils/analyticsDemoData";

const { selectProject, showDialog } = userSlice;

const prodURL = "https://club-lab.ru";
const url =
  window.location.hostname === "localhost" ? "http://localhost:3004" : prodURL;

export default function Author() {
  const dispatch = useDispatch();
  const [gamesData, setGamesData] = useState([]);
  const data = useSelector((state) => state.user?.games);

  useEffect(() => {
    if (data) {
      setGamesData(data);
    }
  }, [data]);

  return (
    <div>
      {!gamesData.length ? (
        <div className="app-empty">
          <h2 className="app-empty__title">Пока нет сценариев</h2>
          <p className="app-empty__desc">
            Создайте первый интерактивный сценарий — кнопка также доступна в меню
            слева
          </p>
          <Button
            variant="contained"
            className="app-btn app-btn--primary app-empty__cta"
            startIcon={<AddIcon />}
            onClick={() => dispatch(showDialog("new"))}
          >
            Создать сценарий
          </Button>
        </div>
      ) : (
        <div className="app-project-grid">
          {gamesData.map((el) => {
            const status = getProjectStatusDisplay(el.settings);
            const accessLabel = getAccessLabel(el.settings);
            const analyticsPreview = getProjectAnalyticsPreview(el, gamesData);

            return (
              <Link
                key={el._id}
                to={`/main/${el._id}`}
                state={{ projectId: el._id, type: "edit" }}
                className="app-project-card app-project-card--link"
                onClick={() => dispatch(selectProject(el._id))}
              >
                <div className="app-project-card__title">{el.title}</div>

                <div className="app-project-card__media">
                  {el.poster ? (
                    <img src={`${url}/${el.poster}`} alt={el.title} />
                  ) : (
                    <div className="upload-container">
                      <div className="upload-icon">
                        <NoPhotographyIcon />
                      </div>
                    </div>
                  )}
                </div>

                {analyticsPreview.hasData ? (
                  <div className="app-project-card__analytics">
                    <div className="app-project-card__analytics-head">
                      <span>Аналитика</span>
                      {analyticsPreview.isDemo ? (
                        <span className="app-project-card__analytics-badge">
                          демо
                        </span>
                      ) : null}
                    </div>
                    <div className="app-project-card__analytics-grid">
                      <div className="app-project-card__analytics-item">
                        <strong>
                          {formatAnalyticsCount(analyticsPreview.starts)}
                        </strong>
                        <span>Запусков</span>
                      </div>
                      <div className="app-project-card__analytics-item">
                        <strong>
                          {formatAnalyticsCount(analyticsPreview.completions)}
                        </strong>
                        <span>Завершений</span>
                      </div>
                      <div className="app-project-card__analytics-item">
                        <strong>{analyticsPreview.conversion}%</strong>
                        <span>Конверсия</span>
                      </div>
                    </div>
                  </div>
                ) : null}

                <div className="app-project-card__meta">
                  <div className="app-project-card__meta-row">
                    <span>Статус</span>
                    <span
                      className={`app-project-card__status app-project-card__status--${status.tone}`}
                    >
                      {status.label}
                    </span>
                  </div>
                  <div className="app-project-card__meta-row">
                    <span>Доступ</span>
                    <span>{accessLabel}</span>
                  </div>
                  <div className="app-project-card__meta-row">
                    <span>Сцен</span>
                    <span>
                      {el.nodes?.filter((node) => node.type === "group")?.length ??
                        0}
                    </span>
                  </div>
                  <div className="app-project-card__meta-row">
                    <span>Описание</span>
                    <span>{el.description ? "Есть" : "Нет"}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
